export default __webpack_public_path__ + "static/media/Neutraface2Display-Titling.6c20a4da.otf";